<template>
    <div class="ReportStartEndDateFilterBar">
        <div class="container-fluid">
          <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
            <div class="col-md-2 col-lg-2">
            </div>  
            <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
              Start date
            </div>    
            <div class="col-md-3 col-lg-3">
                <div class="form-group">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                      <date-picker v-model="date1" :config="config"></date-picker>
                    </div>
                </div>
            </div>
            <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
                End date
            </div>    
            <div class="col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                    <date-picker v-model="date2" :config="config"></date-picker>
                  </div>
                </div>
            </div>
            <div class="col-md-2 col-lg-2">
            </div>
          </div>
          <div class="row vertical-align margin-top-4Perc margin-bottom-2Perc">
            <div class="col-md-1 col-lg-1">
            </div>  
            <div class="col-md-2 col-lg-2 text-align-right padding-left-right-0Px">
                Group Course(s)
            </div>    
            <div class="col-md-3 col-lg-3">
                <div class="form-group">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                        <select class="form-control" v-model="selectedGroupObj">
                          <option value=-1 disabled>Select</option>
                          <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
                Cohort(s)
            </div>    
            <div class="col-md-3 col-lg-3">
                <div class="form-group">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                        <select class="form-control" v-model="selectedCohortObj">
                        <option value='-1' disabled>Select</option>
                        <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                      </select> 
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-lg-2">
          </div>
            <!-- <div class="col-md-1 col-lg-1">
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">View</button>
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
            </div> -->
          </div>

          <div class="row vertical-align margin-top-4Perc margin-bottom-4Perc">
            <div class="col-md-5 col-lg-5">
            </div>    
            <div class="col-md-1 col-lg-1">
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">View</button>
            </div>
            <div class="col-md-1 col-lg-1">
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
            </div>
            <div class="col-md-5 col-lg-5">
          </div>
            <!-- <div class="col-md-1 col-lg-1">
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">View</button>
              <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
            </div> -->
          </div>
            <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
            <!-- Show Spinner -->
            <div class="animationload" v-show="showSpinner">
              <div class="osahanloading"></div>
            </div>
            <loader></loader>      
        </div>
    </div>    
</template>

<script>
import moment from 'moment-timezone'
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
export default {
  props: ['showExport'],
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    var date1 = moment().tz('America/New_York').add(-7, 'days').format('MM/DD/YYYY')
    var date2 = moment().tz('America/New_York').format('MM/DD/YYYY')
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      associatedCohortList: [],
      UserObjList: [],
      date1: date1,
      config: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
        maxDate: ''
      },
      date2: date2
    }
  },
  methods: {
    setDefaultValues: function () {
      this.config.maxDate = new Date()
      // console.log('this.$store.state.selectedGroupCourseObj >>> ' + JSON.stringify(this.$store.state.selectedGroupCourseObj))
      // console.log('this.$store.state.selectedCohortObj >>> ' + JSON.stringify(this.$store.state.selectedCohortObj))
      if (!isEmpty(this.$store.state.selectedGroupCourseObj)) {
        this.selectedGroupObj = this.$store.state.selectedGroupCourseObj
      }
      if (!isEmpty(this.$store.state.selectedCohortObj)) {
        this.selectedCohortObj = this.$store.state.selectedCohortObj
      }
      // console.log('Report Start End Date this.selectedGroupObj >>> ' + JSON.stringify(this.selectedGroupObj))
      // console.log('Report Start End Date length >>> ' + this.selectedGroupObj.length)
      // console.log('Report Start End Date this.selectedCohortObj >>> ' + JSON.stringify(this.selectedCohortObj))
      // console.log('Report Start End Date length >>> ' + this.selectedCohortObj.length)
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedGroupObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          if (this.date1 !== null) {
            if (this.date2 !== null) {
              // AK: Emit selected Group Course cohort start and End date obj
              this.$emit('selectedGroupObj', this.selectedGroupObj)
              this.$emit('selectedCohortObj', this.selectedCohortObj)
              this.$emit('selectedStartDate', this.date1)
              this.$emit('selectedEndDate', this.date2)
              this.$store.state.selectedGroupCourseObj = this.selectedGroupObj
              this.$store.state.selectedCohortObj = this.selectedCohortObj
              if (isExportBtnClicked) {
                this.$emit('isExportBtnClicked', true)
                this.$emit('isViewBtnClicked', false)
              } else {
                this.$emit('isExportBtnClicked', false)
                this.$emit('isViewBtnClicked', true)
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg =
              'Please select an end date.'
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg =
            'Please select a start date.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group course.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      if (!isEqual(this.selectedGroupObj, this.$store.state.selectedGroupCourseObj)) {
        this.selectedCohortObj = -1
      }
      // this.selectedCohortObj = -1
      this.getAssociatedCohortList()
    }
  },
  name: 'ReportStartEndDateFilterBar'
}
</script>

<style scoped>
.ReportStartEndDateFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.padding-left-1Perc {
  padding-left: 1% !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-4Perc {
  margin-top: 4%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width-15px{
  width: 15%;
}
.margin-left-4Perc{
  margin-left:4% !important;
}
.text-align-right{
  text-align: right;
}
.width-7Perc{
  width:7% !important;
}
.margin-left-1Point5Perc{
  margin-left: 1.5% !important;
}

.margin-bottom-4Perc{
  margin-bottom:4% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ReportStartEndDateFilterBar.vue